type FilestackPhotoHandles = {
  original?: {
    any?: string
  }
}

type ImagePickerSelection = {
  handle: string
  filestackPhoto?: FilestackPhotoHandles | Record<string, unknown>
}

/**
 * Prefer the original Filestack handle from library metadata when picking from uploaded images.
 * URL path segments are often resized variants; setup_photos needs the original handle.
 */
export function resolveImagePickerHandle({ handle, filestackPhoto }: ImagePickerSelection): string {
  const photo = filestackPhoto as FilestackPhotoHandles | undefined
  return photo?.original?.any ?? handle
}
